module.exports = __webpack_public_path__ + "static/img/console2.e483d6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/console2.png
// module id = J8AE
// module chunks = 1